import React, { useState, useEffect, useContext } from "react";
import { Header } from "antd/lib/layout/layout";
import { Col, Row, Menu, Dropdown, Avatar, Select } from "antd";
import {
  DownOutlined,
  SettingOutlined,
  LogoutOutlined,
  UserOutlined,
  DownCircleFilled,
  ArrowDownOutlined,
  CaretDownFilled,
} from "@ant-design/icons";
// import { useHistory } from "react-router-dom";

import "./index.css";
import { getApi } from "../../helpers";
import { StoreContext } from "../../context";
import { getRoleLabel, hasLockedStore, isOperationsOnlyRole } from "../../helpers/permissions";
import LiveOrderChip from "../../components/LiveOrderChip";

export default function Headers({ isDarkMode = false, toggleTheme }) {
  const { storeId, setStoreId } = useContext(StoreContext);
  const [stores, setStores] = useState([]);
  const [roleLabel, setRoleLabel] = useState("Admin Login");
  // Store managers and Operations staff are locked to their own store.
  const showStorePicker = !hasLockedStore();
  const showLiveOrders = !isOperationsOnlyRole();

  useEffect(() => {
    if (!hasLockedStore()) getStores();
    setRoleLabel(getRoleLabel());
  }, []);

  const getStores = async () => {
    const res = await getApi({}, "getStores", "dashboard/");
    if (res.data && res.data.length) setStores(res.data);
  };

  const logOutHandler = () => {
    localStorage.removeItem("theme");
    localStorage.removeItem("token");
    localStorage.removeItem("user_role_id");
    localStorage.removeItem("user_data");
    localStorage.removeItem("storeId");
    setTimeout(() => {
      // history.replace("/login");
      window.location.reload();
    }, 500);
  };

  return (
    <Header className="hdr">
      <div className="hdr__content">
        <div className="hdr__right">
          {showLiveOrders && <LiveOrderChip />}
          {showStorePicker && (
            <>
              <Select
                style={{ width: 200 }}
                key="store"
                placeholder="Select your Store"
                onChange={(value) => setStoreId(value)}
                value={storeId}
                allowClear
              >
                {stores.map((store) => (
                  <Select.Option value={store.store_id}>
                    {store.name}
                  </Select.Option>
                ))}
              </Select>
            </>
          )}
          <div>
            <Dropdown
              // arrow
              trigger={["click"]}
              placement="topCenter"
              overlay={
                <Menu style={{ marginTop: -10 }}>
                  <Menu.Item onClick={toggleTheme} key="setting">
                    <SettingOutlined style={{ marginRight: 8 }} />
                    {isDarkMode ? "Light Mode" : "Dark Mode"}
                  </Menu.Item>
                  <Menu.Item onClick={logOutHandler} key="logout">
                    <LogoutOutlined style={{ marginRight: 8 }} />
                    Logout
                  </Menu.Item>
                </Menu>
              }
            >
              <a
                href="#"
                style={{
                  fontSize: 15,
                  display: "inline-flex",
                  alignItems: "center",
                  color: isDarkMode ? "#ffffff" : "#000000",
                }}
                onClick={(e) => e.preventDefault()}
              >
                <Avatar
                  style={{
                    backgroundColor: isDarkMode ? "#ffffff" : "#000000",
                    marginRight: 6,
                  }}
                  icon={
                    <UserOutlined
                      style={{
                        color: isDarkMode ? "#000000" : "#ffffff",
                      }}
                    />
                  }
                  size="small"
                />
                {roleLabel}
                <CaretDownFilled
                  style={{
                    fontSize: 15,
                    marginLeft: 2,
                    color: isDarkMode ? "#ffffff" : "#000000",
                  }}
                />
              </a>
            </Dropdown>
          </div>
        </div>
      </div>
    </Header>
  );
}
